import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BrandM } from '@sorare/core/src/atoms/typography';
import { Trapezoid } from '@sorare/core/src/atoms/ui/Trapezoid';
import { useCommonGameSet } from '@sorare/core/src/set';

const Root = styled(Trapezoid)`
  background: var(--c-set-main-color);
`;

export const InviteTitle = () => {
  const { SetIcon } = useCommonGameSet().visual.brand;
  return (
    <Root>
      <BrandM color="var(--c-black)">
        <Horizontal gap={0.5} center>
          <SetIcon size={3} />
          <FormattedMessage defaultMessage="Invite your friends" />
        </Horizontal>
      </BrandM>
    </Root>
  );
};
